<script>
    import { push } from 'svelte-spa-router';
    import Page from 'components/Page';
    import NavBar from 'components/NavBar';
    import AnnouncementBanner from 'components/AnnouncementBanner';

    // Brand contact data sorted alphabetically
    const brandContacts = [
        {
            brand: 'Acros',
            vendor: 'A.S Bryden',
            address: '1 Ibis Ave, San Juan',
            phone: '(868) 674-9191',
            email: 'inquiry@brydenstt.com',
            website: 'brydenstt.com',
        },
        {
            brand: 'Aiwa',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'All Furniture (bedroom, living, dining)',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'Auraloom',
            vendor: 'Advance Foam',
            address: 'Orange Grove Estate, Tacarigua',
            phone: '(868) 612-1789 / 640-6200',
            email: 'admin@adfoam.com',
            website: 'https://www.adfoam.com',
        },
        {
            brand: 'Drija',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'Electrolux',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'Frigidaire',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'General Electric (GE)',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'Hisense',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'Ignis',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'Inspire',
            vendor: 'Advance Foam',
            address: 'Orange Grove Estate, Tacarigua',
            phone: '(868) 612-1789 / 640-6200',
            email: 'admin@adfoam.com',
            website: 'https://www.adfoam.com',
        },
        {
            brand: 'LG Appliances',
            vendor: 'ProParts Solutions Limited',
            address: '21A Johnny King Road, Aranguez, San Juan',
            phone: '(868) 303-5273 / 297-1597',
            email: 'ravindra.bharat@proparts.com.tt',
            website: 'https://www.lg.com/cac/soporte',
        },
        {
            brand: 'LG TV & Audio',
            vendor: 'Khalian System',
            address: '103 Long Circular Rd, St James',
            phone: '(868) 628-2042',
            email: 'rhenry@ksltt.com',
            website: 'https://www.lg.com/cac/soporte',
        },
        {
            brand: 'Magnum',
            vendor: 'Luxsam Industries Limited',
            address: '4 Gaston Street, Lange Park, Chaguanas',
            phone: '(868) 665-0001',
            email: 'Luxsam.industries@gmail.com',
            website: 'luxsamltd.com',
        },
        {
            brand: 'Maxsonic and Maxsonic Elite',
            vendor: 'BM Electronics',
            address: 'Lot 1&2, Trincity Boulevard, Trincity Business Park, Trincity',
            phone: '(868) 280-9737',
            email: 'bm@bmelectronicslimited.com',
            website: 'bmelectronics.com',
        },
        {
            brand: 'RCA',
            vendor: 'Standard Credit',
            address: 'Ansa McAl Center Chaguanas',
            phone: '(868) 299-0219',
            email: 'standards.customercare@ansamcal.com',
            website: 'standardcredit.mytermfinance.com',
        },
        {
            brand: 'Samsung Appliances',
            vendor: 'Samsung Support',
            address: 'N/A',
            phone: 'N/A',
            email: 'N/A',
            website: 'Samsung.com/support',
        },
        {
            brand: 'Samsung TV & Audio',
            vendor: 'Samsung',
            address: '2 Allahar Street, La Romain',
            phone: '(868) 222-9200',
            email: 'support@diamond-sys.com',
            website: '',
        },
        {
            brand: 'Sealy',
            vendor: 'Advance Foam',
            address: 'Orange Grove Estate, Tacarigua',
            phone: '(868) 612-1789 / 640-6200',
            email: 'admin@adfoam.com',
            website: 'https://www.adfoam.com',
        },
        {
            brand: 'Serta',
            vendor: 'Advance Foam',
            address: 'Orange Grove Estate, Tacarigua',
            phone: '(868) 612-1789 / 640-6200',
            email: 'admin@adfoam.com',
            website: 'https://www.adfoam.com',
        },
        {
            brand: 'Speed Queen',
            vendor: 'A.S Bryden / Brydens Trinidad & Tobago',
            address: '1 Ibis Ave, San Juan',
            phone: '(868) 674-9191',
            email: 'inquiry@brydenstt.com',
            website: 'brydenstt.com',
        },
        {
            brand: 'Therapedic',
            vendor: 'Advance Foam',
            address: 'Orange Grove Estate, Tacarigua',
            phone: '(868) 612-1789 / 640-6200',
            email: 'admin@adfoam.com',
            website: 'https://www.adfoam.com',
        },
        {
            brand: 'Whirlpool',
            vendor: 'A.S Bryden',
            address: '1 Ibis Ave, San Juan',
            phone: '(868) 674-9191',
            email: 'inquiry@brydenstt.com',
            website: 'brydenstt.com',
        },
    ];

    // Track which brand accordion is open
    let openBrand = null;

    function toggleBrand(brand) {
        openBrand = openBrand === brand ? null : brand;
    }

    function formatWebsite(website) {
        if (!website || website === 'N/A') return null;
        if (website.startsWith('http')) return website;
        return `https://${website}`;
    }
</script>

<svelte:head>
    <title>Service & Warranties - Standard Credit</title>
    <meta
        name="description"
        content="Customer Care & Warranty Assistance - Get guidance, reliable information, and support for your appliance warranty claims through our authorized service partners."
    />
</svelte:head>

<NavBar
    activeLink="servicewarranties"
    on:register={() => push('/register')}
    on:hpcustomers={() => push('/hp-customers')}
    on:servicewarranties={() => push('/service-warranties')}
    on:login={() => push('/login')}
/>
<AnnouncementBanner />
<div class="root">
    <Page>
        <div slot="content">
            <!-- Hero Section -->
            <section class="hero">
                <div class="hero__container">
                    <h1 class="hero__title">Customer Care & Warranty Assistance</h1>
                    <p class="hero__subtitle">Support for Your Appliance Warranty and Service Needs</p>
                </div>
            </section>

            <!-- Main Content -->
            <section class="content-section">
                <div class="content-container">
                    <!-- Intro Card -->
                    <div class="card">
                        <p class="card__text">
                            We are committed to ensuring that you continue to receive clear guidance, reliable
                            information, and the appropriate support for your appliance—whether it is under warranty or
                            outside of warranty coverage. This guide outlines what is covered under warranty, how your
                            purchase is validated, and how to access service support by brand through our authorized
                            service partners.
                        </p>
                    </div>

                    <!-- Warranty Coverage Overview -->
                    <div class="warranty-section">
                        <h2 class="section-title">Warranty Coverage Overview</h2>
                        <p class="section-description">
                            Warranty coverage applies to products that meet the manufacturer's terms and conditions and
                            are supported by valid proof of purchase.
                        </p>

                        <div class="coverage-grid">
                            <!-- What's Covered -->
                            <div class="coverage-card coverage-card--included">
                                <div class="coverage-card__header">
                                    <i class="fa-solid fa-check-circle"></i>
                                    <h3>Typical warranty coverage includes:</h3>
                                </div>
                                <ul class="coverage-list">
                                    <li>Manufacturer defects in materials or workmanship</li>
                                    <li>Eligible functional failures occurring within the warranty period</li>
                                    <li>Repairs or replacement of defective components, subject to warranty terms</li>
                                </ul>
                            </div>

                            <!-- What's Not Covered -->
                            <div class="coverage-card coverage-card--excluded">
                                <div class="coverage-card__header">
                                    <i class="fa-solid fa-times-circle"></i>
                                    <h3>Warranty coverage does not include:</h3>
                                </div>
                                <ul class="coverage-list">
                                    <li>Damage caused by misuse, abuse, or improper installation</li>
                                    <li>Normal wear and tear</li>
                                    <li>Cosmetic damage not affecting performance</li>
                                    <li>Unauthorized repairs or modifications</li>
                                </ul>
                            </div>
                        </div>

                        <p class="section-note">
                            Warranty coverage may vary by brand, product category, and warranty type. Customers are
                            encouraged to review the specific link below for detailed warranty information.
                        </p>
                    </div>

                    <!-- Brand Selection Section -->
                    <div class="brands-section">
                        <h2 class="section-title">Brand Contact Information</h2>
                        <p class="section-description">
                            <em>Please select the brand of your item below for instructions on how to proceed</em>
                        </p>

                        <div class="brands-accordion">
                            {#each brandContacts as contact}
                                <div class="accordion-item" class:accordion-item--open={openBrand === contact.brand}>
                                    <button
                                        class="accordion-header"
                                        on:click={() => toggleBrand(contact.brand)}
                                        aria-expanded={openBrand === contact.brand}
                                    >
                                        <span class="accordion-header__brand">{contact.brand}</span>
                                        <i
                                            class="fa-solid fa-chevron-down accordion-header__icon"
                                            class:accordion-header__icon--open={openBrand === contact.brand}
                                        ></i>
                                    </button>
                                    {#if openBrand === contact.brand}
                                        <div class="accordion-content">
                                            <div class="contact-details">
                                                <div class="contact-row">
                                                    <span class="contact-label">
                                                        <i class="fa-solid fa-building"></i>
                                                        Vendor:
                                                    </span>
                                                    <span class="contact-value">{contact.vendor}</span>
                                                </div>
                                                <div class="contact-row">
                                                    <span class="contact-label">
                                                        <i class="fa-solid fa-location-dot"></i>
                                                        Address:
                                                    </span>
                                                    <span class="contact-value">{contact.address}</span>
                                                </div>
                                                <div class="contact-row">
                                                    <span class="contact-label">
                                                        <i class="fa-solid fa-phone"></i>
                                                        Phone:
                                                    </span>
                                                    <span class="contact-value">{contact.phone}</span>
                                                </div>
                                                <div class="contact-row">
                                                    <span class="contact-label">
                                                        <i class="fa-solid fa-envelope"></i>
                                                        Email:
                                                    </span>
                                                    {#if contact.email && contact.email !== 'N/A'}
                                                        <a href="mailto:{contact.email}" class="contact-link">
                                                            {contact.email}
                                                        </a>
                                                    {:else}
                                                        <span class="contact-value">N/A</span>
                                                    {/if}
                                                </div>
                                                {#if formatWebsite(contact.website)}
                                                    <div class="contact-row">
                                                        <span class="contact-label">
                                                            <i class="fa-solid fa-globe"></i>
                                                            Website:
                                                        </span>
                                                        <a
                                                            href={formatWebsite(contact.website)}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            class="contact-link"
                                                        >
                                                            {contact.website}
                                                        </a>
                                                    </div>
                                                {/if}
                                            </div>
                                        </div>
                                    {/if}
                                </div>
                            {/each}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </Page>
</div>

<style lang="scss">
    @use 'src/sass/base' as *;

    .root {
        min-height: 100vh;
        background: $color-white;
    }

    .hero {
        position: relative;
        margin-top: 65px;
        padding: em(60) em(25) em(50) em(25);
        text-align: center;
        background-image: url(/images/bg_1@2x.jpg);
        background-size: cover;
        background-position: center 35%;
        background-repeat: no-repeat;
        min-height: 300px;

        // Dark overlay
        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.6);
            z-index: 1;
        }

        @include for-tablet-portrait-up {
            padding: em(80) em(40) em(60) em(40);
            min-height: 350px;
        }

        @include for-tablet-landscape-up {
            min-height: 380px;
        }

        &__container {
            position: relative;
            z-index: 2;
            max-width: 900px;
            margin: 0 auto;
            text-align: center;
        }

        &__title {
            font-size: em(32);
            font-weight: $fw-bold;
            background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(0, 188, 242, 1) 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-bottom: em(20);
            line-height: 1.2;

            @include for-tablet-portrait-up {
                font-size: em(48);
            }

            @include for-tablet-landscape-up {
                font-size: em(56);
            }
        }

        &__subtitle {
            font-size: em(18);
            font-weight: $fw-regular;
            color: rgba($color-white, 0.9);
            line-height: 1.5;
            text-align: center;

            @include for-tablet-portrait-up {
                font-size: em(22);
            }
        }
    }

    .content-section {
        padding: em(60) em(25);

        @include for-tablet-portrait-up {
            padding: em(80) em(40);
        }
    }

    .content-container {
        max-width: 1000px;
        margin: 0 auto;
    }

    .card {
        background: $color-white;
        border-radius: em(12);
        padding: em(40) em(30);
        margin-bottom: em(50);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        @include for-tablet-portrait-up {
            padding: em(50) em(40);
        }

        &__text {
            font-size: em(18);
            font-weight: $fw-regular;
            color: $color-gray-text;
            line-height: 1.7;

            @include for-tablet-portrait-up {
                font-size: em(20);
            }
        }
    }

    .warranty-section {
        margin-bottom: em(50);
    }

    .section-title {
        font-size: em(28);
        font-weight: $fw-bold;
        color: $color-primary;
        margin-bottom: em(20);
        text-align: center;

        @include for-tablet-portrait-up {
            font-size: em(32);
        }
    }

    .section-description {
        font-size: em(18);
        color: $color-gray-text;
        line-height: 1.6;
        text-align: center;
        margin-bottom: em(30);
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;

        @include for-tablet-portrait-up {
            font-size: em(20);
        }
    }

    .section-note {
        font-size: em(16);
        color: $color-gray-text;
        line-height: 1.6;
        text-align: center;
        margin-top: em(30);
        font-style: italic;

        @include for-tablet-portrait-up {
            font-size: em(18);
        }
    }

    .coverage-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: em(30);

        @include for-tablet-portrait-up {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    .coverage-card {
        background: $color-white;
        border-radius: em(12);
        padding: em(30);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        &--included {
            border-top: 4px solid #22c55e;

            .coverage-card__header i {
                color: #22c55e;
            }
        }

        &--excluded {
            border-top: 4px solid #ef4444;

            .coverage-card__header i {
                color: #ef4444;
            }
        }

        &__header {
            display: flex;
            align-items: center;
            gap: em(12);
            margin-bottom: em(20);

            i {
                font-size: em(24);
            }

            h3 {
                font-size: em(18);
                font-weight: $fw-bold;
                color: $color-black;
                margin: 0;

                @include for-tablet-portrait-up {
                    font-size: em(20);
                }
            }
        }
    }

    .coverage-list {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            position: relative;
            padding-left: em(24);
            margin-bottom: em(12);
            font-size: em(16);
            color: $color-gray-text;
            line-height: 1.5;

            &::before {
                content: '•';
                position: absolute;
                left: 0;
                color: $color-primary;
                font-weight: bold;
            }

            &:last-child {
                margin-bottom: 0;
            }

            @include for-tablet-portrait-up {
                font-size: em(17);
            }
        }
    }

    .brands-section {
        margin-bottom: em(50);
    }

    .brands-accordion {
        display: flex;
        flex-direction: column;
        gap: em(8);
    }

    .accordion-item {
        background: $color-white;
        border-radius: em(8);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        transition: box-shadow 0.3s ease;

        &:hover {
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        }

        &--open {
            box-shadow: 0 4px 16px rgba(0, 126, 202, 0.15);
        }
    }

    .accordion-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: em(18) em(24);
        background: transparent;
        border: none;
        cursor: pointer;
        text-align: left;
        transition: background-color 0.2s ease;

        &:hover {
            background-color: rgba($color-primary, 0.05);
        }

        &__brand {
            font-size: em(18);
            font-weight: $fw-medium;
            color: $color-black;

            @include for-tablet-portrait-up {
                font-size: em(20);
            }
        }

        &__icon {
            color: $color-primary;
            transition: transform 0.3s ease;

            &--open {
                transform: rotate(180deg);
            }
        }
    }

    .accordion-content {
        padding: 0 em(24) em(24) em(24);
        animation: slideDown 0.3s ease;
    }

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .contact-details {
        background: $color-secondary;
        border-radius: em(8);
        padding: em(20);
    }

    .contact-row {
        display: flex;
        flex-direction: column;
        gap: em(4);
        margin-bottom: em(16);

        @include for-tablet-portrait-up {
            flex-direction: row;
            gap: em(12);
            align-items: flex-start;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .contact-label {
        font-size: em(14);
        font-weight: $fw-bold;
        color: $color-gray-text;
        display: flex;
        align-items: center;
        gap: em(8);
        min-width: 100px;

        i {
            color: $color-primary;
            width: 16px;
            text-align: center;
        }

        @include for-tablet-portrait-up {
            font-size: em(16);
        }
    }

    .contact-value {
        font-size: em(16);
        color: $color-black;

        @include for-tablet-portrait-up {
            font-size: em(17);
        }
    }

    .contact-link {
        font-size: em(16);
        color: $color-primary;
        text-decoration: none;
        transition: color 0.2s ease;
        word-break: break-word;

        &:hover {
            color: darken($color-primary, 10%);
            text-decoration: underline;
        }

        @include for-tablet-portrait-up {
            font-size: em(17);
        }
    }
</style>
